// export const url = "http://ec2-3-145-162-172.us-east-2.compute.amazonaws.com:4000";
export const url = "https://chainrents.com";
// export const url = "http://ec2-54-196-143-15.compute-1.amazonaws.com:8080";
//export const url = "http://192.168.86.89:4000";
export const themeColor = "#E6E6FA";
